import { render, staticRenderFns } from "./customProfileImageInput.vue?vue&type=template&id=0cc4b134&scoped=true"
import script from "./customProfileImageInput.vue?vue&type=script&lang=js"
export * from "./customProfileImageInput.vue?vue&type=script&lang=js"
import style0 from "./customProfileImageInput.vue?vue&type=style&index=0&id=0cc4b134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4b134",
  null
  
)

export default component.exports